import axios from 'axios';
import { API_CONFIG } from '../config/apiConfig';

export interface SellerTrainingProgress {
  distributorCode: string;
  distributorName: string;
  site: string;
  username: string;
  role: string;
  location: string;
  trainername: string;
  moduleName: string;
  moduleStatus: string;
  completionTime: string | null;
  
  // Quiz related fields
  quizCompleted: number;
  quizScore: number;
  quizPoints: number;
  quizPointsConfigured: number;
  
  // Reels related fields
  reelsViewed: number;
  reelsConfigured: number;
  reelsPoints: number;
  reelsPointsConfigured: number;
  
  // In Market related fields
  inMarketCompleted: number;
  inMarketPoints: number;
  inMarketPointsConfigured: number;
  
  // Mock Call related fields
  mockCallCompleted: number;
  mockCallPoints: number;
  mockCallPointsConfigured: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export const reportsService = {
  getSellerTrainingProgress: async (
    distributorCode?: string, 
    page: number = 1, 
    pageSize: number = 50, 
    filters: { seller: string; trainer: string; module: string } = { seller: '', trainer: '', module: '' }
  ): Promise<PaginatedResponse<SellerTrainingProgress>> => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/Reports/SellerTrainingProgress`, {
        params: { 
          distributorCode: distributorCode || undefined,
          page,
          pageSize,
          seller: filters.seller || undefined,
          trainer: filters.trainer || undefined,
          module: filters.module || undefined
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching seller training progress:', error);
      throw error;
    }
  },

  // Export method - gets all records by using a very large page size
  exportSellerTrainingProgress: async (
    distributorCode?: string,
    filters: { seller: string; trainer: string; module: string } = { seller: '', trainer: '', module: '' }
  ): Promise<SellerTrainingProgress[]> => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/Reports/SellerTrainingProgress`, {
        params: { 
          distributorCode: distributorCode || undefined,
          page: 1,
          pageSize: 100000, // Very large page size to get all records
          seller: filters.seller || undefined,
          trainer: filters.trainer || undefined,
          module: filters.module || undefined
        }
      });
      return response.data.data; // Extract just the data array from the response
    } catch (error) {
      console.error('Error exporting seller training progress:', error);
      throw error;
    }
  },

  // Add other report methods here as needed
  // getModuleExecutionReport: async (params: any) => { ... },
  // getBeltProgressReport: async (params: any) => { ... },
}; 